import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import './../styles/layout.css';

const Layout = () => {
  return (
    <div className="app-container">
      <Navbar />
      <div className="main-content">
        <Outlet />
      </div>
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Print Record News &mdash; Media Intelligence Platform</p>
      </footer>
    </div>
  );
};

export default Layout;
